import { axios } from "../../../lib/axios";

export const GetTransactionsCard = async (name: any): Promise<any> => {
  let response;
  if (name !== "") {
    response = await axios.get(`/cards?name=${name}`);
  }
  return response != undefined ? response.data : [];
};
